<template>
  <v-container class="no-p" fluid>
    <v-app-bar app>
      <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
      <v-toolbar-title>{{language.account_information}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="logOut">
        <v-icon color="red darken-1">mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
    <div class="list-of-content" v-if="profile.length > 0">
      <v-list three-line>
        <template>
          <v-list-item v-if="profile.length > 0">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title">{{language.account_information}}</v-list-item-title>
              <!-- <v-list-item-subtitle v-html="item.content"></v-list-item-subtitle> -->
              <table class="list-of-content__details">
                <tr v-if="profile[0].codigo!=''">
                  <th>{{language.code}}</th>
                  <td>{{profile[0].codigo}}</td>
                </tr>
                <tr v-if="profile[0].nombre!=''">
                  <th>{{language.name}}</th>
                  <td>{{profile[0].nombre}}</td>
                </tr>
                <tr v-if="profile[0].descripcion_oficina!=''">
                  <th>{{language.office}}</th>
                  <td>{{profile[0].descripcion_oficina}}</td>
                </tr>
                <tr v-if="profile[0].sector!=''">
                  <th>{{language.sector}}</th>
                  <td>{{profile[0].sector}}</td>
                </tr>
                <tr v-if="profile[0].direccion_oficina!=''">
                  <th>{{language.office_address}}</th>
                  <td>{{profile[0].direccion_oficina}}</td>
                </tr>
                <tr v-if="profile[0].email_address_oficina!=''">
                  <th>{{language.email_office}}</th>
                  <td>{{profile[0].email_address_oficina}}</td>
                </tr>
                <tr v-if="profile[0].telefono1_oficina!=''">
                  <th>{{language.phone}} 1</th>
                  <td>{{profile[0].telefono1_oficina}}</td>
                </tr>
                <tr v-if="profile[0].telefono2_oficina!=''">
                  <th>{{language.phone}} 2</th>
                  <td>{{profile[0].telefono2_oficina}}</td>
                </tr>
              <tr v-if="profile[0].horario!=''">
                  <th>{{language.schedule}}</th>
                  <td>{{profile[0].horario}}</td>
               </tr>

<tr>
                  <td colspan="2">
                    <table class="list-of-content__details">
                      <tr>
                        <td  v-if="profile[0].whatsapp!=''">
                            <v-btn
                              text
                              small
                              color="primary"
                              @click="openUrl(profile[0].whatsapp)"
                            ><img src="@/assets/003-whatsapp.svg" alt="WhatsApp" width="40"></v-btn>
                          </td>
                          <td v-if="profile[0].instagram!=''">
                            <v-btn
                              text
                              small
                              color="primary"
                              @click="openUrl(profile[0].instagram)"
                            ><img src="@/assets/002-instagram.svg" alt="Instagram" width="40"></v-btn>
                          </td>
                          <td v-if="profile[0].facebook!=''">
                            <v-btn
                              text
                              small
                              color="primary"
                              @click="openUrl(profile[0].facebook)"
                            ><img src="@/assets/004-facebook.svg" alt="Facebook" width="40"></v-btn>
                          </td>
                          <td v-if="profile[0].twiiter!=''">
                            <v-btn
                              text
                              small
                              color="primary"
                              @click="openUrl(profile[0].twiiter)"
                            ><img src="@/assets/006-twitter.svg" alt="Twiiter" width="40"></v-btn>
                          </td>

                      </tr>
                    </table>
                  </td>
                </tr>

                <tr v-if="profile[0].website!=''">
                  <th>Website</th>
                  <td>
                    <v-btn
                      text
                      small
                      color="primary"
                      @click="openUrl(profile[0].website)"
                    >{{profile[0].website}}</v-btn>
                  </td>
                </tr>
                <tr v-if="profile[0].puntos!= undefined">
                  <th>Puntos</th>
                  <td>{{profile[0].puntos}}</td>
                </tr>

                <tr>
                  <td colspan="2">
                    <v-btn
                      color="info"
                      class="mb-3 mt-1"
                      block
                      v-if="profile[0].longitud !=='' && profile[0].latitud !==''"
                      @click="openMap(profile[0].longitud,profile[0].latitud,profile[0].descripcion_oficina)"
                    >{{language.see_on_the_map}}</v-btn>
                  </td>
                </tr>

                <!-- <tr>
                  <td colspan="2">
<v-btn
                    color="primary"
                    dark
                    large
                    @click="dialog = true"
                  >
                    {{language.change_language}}
                  </v-btn>
                  </td>
                </tr> -->
              </table>


            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="profile[1]">
            <v-list-item-content>
              <v-list-item-title class="list-of-content__title">{{language.address}} Miami</v-list-item-title>
              <!-- <v-list-item-subtitle v-html="item.content"></v-list-item-subtitle> -->
              <table class="list-of-content__details">
                <tr v-if="profile[1].DIRECCION_FULL">
                  <th>{{language.full_address}}</th>
                  <td>{{profile[1].DIRECCION_FULL}}</td>
                </tr>
                <tr v-if="profile[1].address1">
                  <th>{{language.address}} 1</th>
                  <td>{{profile[1].address1}}</td>
                </tr>
                <tr v-if="profile[1].address2">
                  <th>{{language.address}} 2</th>
                  <td>{{profile[1].address2}}</td>
                </tr>
                <tr v-if="profile[1].city">
                  <th>{{language.city}}</th>
                  <td>{{profile[1].city}}</td>
                </tr>
                <tr v-if="profile[1].state">
                  <th>{{language.state}}</th>
                  <td>{{profile[1].state}}</td>
                </tr>
                <tr v-if="profile[1].telefono_direccion">
                  <th>{{language.phone}}</th>
                  <td>{{profile[1].telefono_direccion}}</td>
                </tr>
                <tr v-if="profile[1].zipcode">
                  <th>{{language.zipcode}}</th>
                  <td>{{profile[1].zipcode}}</td>
                </tr>
              </table>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
      <div class="pl-3 pr-3 pb-5 pt-4">
        <v-btn color="error" @click="logOut" large block>{{language.logout}}</v-btn>
      </div>
    </div>
    <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{language.you_have_no_data_available}}
        </div>
      </div>
      <v-progress-circular :size="90" color="blue" v-else indeterminate class="loading-center"></v-progress-circular>
    </div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >

      <v-card>
        <v-card-title class="headline">
          {{language.change_language}}
        </v-card-title>

        <v-card-text>
          <v-radio-group v-model="currentLang">
            <v-radio
              :label="language.english"
              value="2"
            ></v-radio>
            <v-radio
              :label="language.espanish"
              value="1"
            ></v-radio>

          </v-radio-group>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            {{language.cancel}}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="changeLanguageF"
          >
            {{language.save}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  created() {
    this.$store.watch(
      (state, getters) => getters.user,
      // (newValue, oldValue) => {
      (newValue) => {
        console.log(newValue);
        this.currentUser = newValue;
        if (newValue.pushId !== null && newValue.userName !== null) {
          if (this.currentUser != undefined) {
            console.log(this.currentUser);
            this.getPacks();
          }
        }
      }
    );
  },
  mounted() {
    if(this.currebtLanguage == "es"){
      this.currentLang = 1;
    }else{
      this.currentLang = 2;
    }

    if (this.currentUser != undefined) {
      this.getPacks();
    } else if (this.user.userName != null) {
      this.currentUser = this.user;
      this.getPacks();
    }
  },
  data() {
    return {
      clipped: false,
      currentUser: undefined,
      currentLang: null,
      dialog:false
    };
  },
  computed: {
    noData() {
      return this.profile.length > 0 ? true : false;
    },
    login: function () {
      return this.$store.getters.login;
    },
    user: function () {
      return this.$store.getters.user;
    },
    profile: function () {
      return this.$store.getters.profile;
    },
    language: function () {
      return this.$store.getters.language;
    },
    currebtLanguage:function () {
      return this.$store.getters.currebtLanguage;
    },
  },
  methods: {
    openMap(log, lat, title) {
      window.MobileApi.openLocationInMap(log, lat, title);
    },
    openUrl(url) {
      window.MobileApi.openUrl(url);
    },
    logOut() {
      this.$store.dispatch("logout");
      window.MobileApi.signOut();

      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$http.post(Server.logout, formData).then(
        // response => {},
        () => {},
        () => {}
      );
    },
    getPacks() {
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      this.$store.dispatch("getProfile", {
        Vue: this,
        url: Server.profile,
        data: formData,
      });
    },
    changeLanguageF(){
      var formData = new FormData();
      formData.append("text1", this.currentUser.userName);
      formData.append("text3", this.currentUser.pushId);
      formData.append("device", window.MobileApi.device);
      formData.append("text4", this.currentLang);

      // console.log(this.currentUser);

      this.dialog = false;
      this.$http.post(Server.changeLanguage, formData).then(
        (response) => {
          // console.log(response.body);
          if (response.body.resultado !== "NO") {
            this.getPacks();
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    },
  },
  name: "App",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
